import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { store, } from "./store/store"
import { setApiTokenProvider } from './community-hats-js-library/back-end/router';
import { getApiToken } from './utils/apiTokenFunctions';
import { LanguageProvider } from './providers/LanguageProvider';
// import { PersistGate } from 'redux-persist/integration/react';


// The library calls the application server directly, and the server refuses
// anything without a token. Rather than let it reach into this app's store,
// hand it a way to obtain one before anything can call.
setApiTokenProvider(getApiToken);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
      {/* Inside the store provider: the locale it hands down is read from the store. */}
      <LanguageProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </LanguageProvider>
      {/* </PersistGate> */}
    </Provider>
  </BrowserRouter>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
